import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './SectionAccueil.css';

// Import des médias
import image1 from '../../assets/images/carrouselAcceuil1.webp';
import image2 from '../../assets/images/carrouselAccueil2.jpg';
import image3 from '../../assets/images/AccueuilCarrousel4.webp';
import video1 from '../../assets/videos/videoCarrouel.mp4';
import {Link} from "react-router-dom";

function SectionAccueil() {
    return (
        <section className="section-accueil">
            <Carousel
                autoPlay
                infiniteLoop
                interval={5000}
                showThumbs={false}
                showIndicators={false}
                showArrows={false}
            >
                {/* Vidéo */}
                <div className="carousel-item">
                    <video className="carousel-media" autoPlay muted loop>
                        <source src={video1} type="video/mp4" />
                        Votre navigateur ne supporte pas les vidéos HTML5.
                    </video>
                </div>

                {/* Images */}
                <div className="carousel-item">
                    <img className="carousel-media" src={image1} alt="Image 1" />
                </div>
                <div className="carousel-item">
                    <img className="carousel-media" src={image2} alt="Image 2" />
                </div>
                <div className="carousel-item">
                    <img className="carousel-media" src={image3} alt="Image 2" />
                </div>
            </Carousel>

            {/* Overlay avec Texte et Boutons */}
            <div className="overlay">
                <div className="overlay-content">
                    <h1 className="overlay-title">ENSEMBLE, TOUT EST POSSIBLE</h1>
                    <p className="overlay-paragraph">
                        Avec une passion et un esprit d'équipe inégalés, le Nantes Doulon Bottière Futsal est prêt à conquérir de
                        nouveaux sommets. Rejoignez-nous pour partager cette aventure !
                    </p>
                    <div className="overlay-buttons">
                        <button className="btn-primary">
                            <a href="#prochain-match" className="btn-link">Prochain Match</a>
                        </button>
                        <Link to="/club">
                            <button className="btn-secondary">Découvrir le Club</button>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SectionAccueil;
